import { Tooltip as TooltipComp, TooltipProps } from 'antd';
import React from 'react';

import { getClassName } from '../_utils';

type Props = Pick<
  TooltipProps,
  | 'title'
  | 'className'
  | 'overlayClassName'
  | 'classNames'
  | 'arrow'
  | 'placement'
> & {
  children: TooltipTrigger | readonly TooltipTrigger[];
};

type TooltipTrigger =
  | string
  | React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>;

/**
 * returns JSX for tooltip
 */
export function Tooltip({
  children,
  className = '',
  overlayClassName = '',
  ...restProps
}: Props) {
  return (
    <TooltipComp
      {...restProps}
      destroyOnHidden={false}
      className={getClassName('tooltip', className)}
      classNames={{
        body: `suntex-tooltip-overlay ${overlayClassName}`,
      }}
    >
      <>{children}</>
    </TooltipComp>
  );
}
